import type { BillingCycle } from './teamOfferSelection';
import {
  DEFAULT_UNSUBSCRIBED_SOLO_TIER_ID,
  DEFAULT_UNSUBSCRIBED_TEAM_TIER_ID,
  type PricingTierId,
} from './pricingTierOptions';

export interface PricingEntryDefaultsInput {
  hasCurrentPlan: boolean;
  isTrial: boolean;
  isExpired: boolean;
}

export interface PricingEntryDefaults {
  billingCycle: BillingCycle | null;
  soloTierId: PricingTierId | null;
  teamTierId: PricingTierId | null;
}

export const resolvePricingEntryDefaults = ({
  hasCurrentPlan,
  isTrial,
  isExpired,
}: PricingEntryDefaultsInput): PricingEntryDefaults => {
  const shouldUseUnsubscribedDefaults = !hasCurrentPlan || isTrial || isExpired;

  if (!shouldUseUnsubscribedDefaults) {
    return {
      billingCycle: null,
      soloTierId: null,
      teamTierId: null,
    };
  }

  return {
    billingCycle: 'yearly',
    soloTierId: DEFAULT_UNSUBSCRIBED_SOLO_TIER_ID,
    teamTierId: DEFAULT_UNSUBSCRIBED_TEAM_TIER_ID,
  };
};
